import { createContext } from 'react';
import type { IconSize } from './types';

interface DropdownContextType {
  background: string;
  mainFontColor: string;
  closeOnClick: boolean;
  withoutIcons: boolean;
  iconSize: IconSize;
  onCloseRequest(): void;
}

export const DropdownContext = createContext({} as DropdownContextType);
